module.exports = __webpack_public_path__ + "static/media/tempe-campus.12f1b571.webp";